import React from 'react';
import { APPEARANCES } from '../../Heading';
import {
  CustomHeading,
  CustomLinkRenderer,
  CustomTableDataRenderer,
} from '../defaultRenderers';
import { getMdHeadingId } from '../../../../../utils/locationUtils';

const htmlParser = require('react-markdown/plugins/html-parser');
const HtmlToReact = require('html-to-react');

const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
export const parseHtml = ({
  textWeight,
  textSize,
  textLight,
  dataHooks = {},
  markdownPath = '',
  logger,
  store,
}) =>
  htmlParser({
    isValidNode: (node) => node.type !== 'script',
    processingInstructions: [
      // Order matters. Instructions are processed in the order they're defined
      {
        // Custom heading processing
        shouldProcessNode: (node) =>
          node.type === 'tag' &&
          Object.values(APPEARANCES).includes(node.tagName.toUpperCase()),
        processNode(node, children) {
          const level = node.tagName[1];
          const id = node.attribs && node.attribs.id;
          return CustomHeading({
            markdownPath,
            textLight,
            dataHooks,
          })({
            children,
            level,
            value: id,
          });
        },
      },
      {
        // Custom link processing
        shouldProcessNode: (node) =>
          node.type === 'tag' && node.tagName === 'a',
        processNode(node, children) {
          const href = node.attribs.href;
          return CustomLinkRenderer({
            textSize,
            textWeight,
            textLight,
            dataHooks,
            logger,
            store,
          })({
            href,
            children,
          });
        },
      },
      {
        // Custom table data processing
        shouldProcessNode: (node) =>
          node.type === 'tag' && node.tagName === 'td',
        replaceChildren: true,
        processNode(node, children) {
          return CustomTableDataRenderer({
            children,
          });
        },
      },
      {
        // Anything else with id
        shouldProcessNode: (node) =>
          node.type === 'tag' && node.attribs && node.attribs.id,
        processNode: (node, children, index) => {
          const id = getMdHeadingId(markdownPath, node.attribs.id);
          const attribsWithNewId = { ...node.attribs, id };
          return processNodeDefinitions.processDefaultNode(
            { ...node, attribs: attribsWithNewId },
            children,
            index,
          );
        },
      },
      {
        // Anything else
        shouldProcessNode: () => true,
        processNode: processNodeDefinitions.processDefaultNode,
      },
    ],
  });
